import store from '@/store';

/**
 * Decorator for Vuex action's.
 */
export const togglePendingStoreActions = (namespace = null) => (target, key, descriptor) => {
  const _descriptor = descriptor;
  const orginalMethod = _descriptor.value;
  _descriptor.value = async function (...args) {
    const storeActionsName = namespace ? `${namespace}/${key}` : key;
    store.commit('global/TOGGLE_PENDING_ASYNC_STORE_ACTIONS', storeActionsName);
    await orginalMethod.apply(this, args);
    store.commit('global/TOGGLE_PENDING_ASYNC_STORE_ACTIONS', storeActionsName);
  };
  return descriptor;
};
